import { notify } from '../utils/notify';
import React, { useContext, useState } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { authAPI } from '../services/api';
import { KeyRound, LogOut } from 'lucide-react';
import './ForcePasswordChange.css';

// Shown instead of any page while the user has must_change_password (set when
// an admin resets their password). The backend clears the flag on
// POST /auth/change-password.
const ForcePasswordChange = () => {
  const { user, updateUser, logout } = useContext(AuthContext);
  const { t } = useLanguage();
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      notify(t('New passwords do not match!'), 'warning');
      return;
    }
    try {
      setSaving(true);
      await authAPI.changePassword({
        current_password: form.current_password,
        new_password: form.new_password
      });
      notify(t('Password changed successfully!'), 'success');
      const updated = { ...user, must_change_password: false };
      localStorage.setItem('user', JSON.stringify(updated));
      updateUser(updated);
    } catch (error) {
      notify(error.response?.data?.message || t('Error changing password'), 'error');
    } finally {
      setSaving(false);
    }
  };

  const field = (name, label) => (
    <div className="fpc__field">
      <label className="field-label" htmlFor={name}>{t(label)}</label>
      <input
        className="input"
        id={name}
        type="password"
        value={form[name]}
        onChange={(e) => setForm({ ...form, [name]: e.target.value })}
        minLength={name === 'current_password' ? undefined : 8}
        required
      />
    </div>
  );

  return (
    <div className="fpc">
      <div className="card fpc__card">
      <h2 className="fpc__title">{t('Change Password')}</h2>
      <p className="fpc__lead">{t('Your password was reset. Choose a new one to continue.')}</p>
      <form onSubmit={handleSubmit}>
        {field('current_password', 'Current Password')}
        {field('new_password', 'New Password')}
        {field('confirm_password', 'Confirm New Password')}
        <div className="fpc__actions">
          <button type="button" className="btn btn--secondary" onClick={logout}>
            <LogOut aria-hidden="true" /> {t('Logout')}
          </button>
          <button type="submit" className="btn btn--primary" disabled={saving}>
            <KeyRound aria-hidden="true" /> {t('Change Password')}
          </button>
        </div>
      </form>
      </div>
    </div>
  );
};

export default ForcePasswordChange;
